import { PHASE_COLORS } from "@app/theme/tokens";
import { Box, Typography } from "@mui/material";
import type { ImplementationPhase } from "../types";
import DashboardCard from "./DashboardCard";
import { PendingCardBody } from "./PendingValue";

export default function ImplementationPhaseCard({
  phases,
}: {
  phases: ImplementationPhase[];
}) {
  const total = phases.reduce((sum, phase) => sum + phase.count, 0);

  return (
    <DashboardCard title="Implementation Phase">
      {total === 0 ? (
        <PendingCardBody hint="No mitigation of the register carries an implementation phase yet." />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 2,
            height: "100%",
          }}
        >
          {phases.map((phase) => (
            <Box
              key={phase.phase}
              sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
            >
              <Typography
                variant="body2"
                sx={{ width: 92, flexShrink: 0, color: "text.secondary" }}
              >
                {phase.phase}
              </Typography>
              <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                <Box
                  sx={{
                    height: 22,
                    borderRadius: 0.5,
                    width: `${phase.percentage}%`,
                    bgcolor: PHASE_COLORS[phase.phase.toLowerCase()],
                  }}
                />
              </Box>
              <Typography
                variant="body2"
                sx={{ width: 44, flexShrink: 0, textAlign: "right" }}
              >
                {phase.percentage}%
              </Typography>
            </Box>
          ))}
          <Typography
            variant="caption"
            sx={{ color: "text.secondary", textAlign: "center" }}
          >
            {total} proposed mitigations
          </Typography>
        </Box>
      )}
    </DashboardCard>
  );
}
